import { useTheme } from '@emotion/react';
import { ImageFiles } from '@icon-park/react';
import { memo } from 'react';

import * as styles from './LessonThumbnail.styles';

export type LessonThumbnailProps = {
  href?: string;
  altText?: string;
};

export const LessonThumbnailBase = ({
  href = undefined,
  altText = undefined,
}: LessonThumbnailProps) => {
  const theme = useTheme();

  return href ? (
    <img src={href} css={styles.thumbnailImage} alt={altText} />
  ) : (
    <div css={styles.placeholderImage}>
      <ImageFiles size={48} theme="outline" fill={theme.colors.primary[500]} strokeWidth={1} />
    </div>
  );
};

LessonThumbnailBase.displayName = 'LessonThumbnail';

export const LessonThumbnail = memo(LessonThumbnailBase);
